<template>
  <div class="g-bd bg-gray">about</div>
</template>
<script>
export default {
  name: "About",
  props: {
    s: {
      type: String
    }
  },
  watch: {},
  data() {
    return {};
  },
  mounted() {
    console.log("about");
    
  },
  methods: {}
};
</script>